import CrudService from "@/services/CrudService";
import i18n from "@/i18n";
import MessageDispatcher from "@/store/Crud/classes/MessageDispatcher";
import isString from "lodash/isString";
/**
 * Basic CRUD actions
 */
export default class CrudActions extends MessageDispatcher {
    crudService = new CrudService();
    constructor() {
        super();
    }
    /**
     * @param store
     * @param options
     */
    async getOne(store, options) {
        store.commit("IS_LOADING", !options.disabledLoading);
        const request = this.crudService.getOne(options);
        request
            .then((response) => {
            this.resolveSingleAction(store, response, options);
        })
            .catch((error) => {
            this.rejectReadAction(store, error, options);
        });
        return request;
    }
    /**
     * @param store
     * @param options
     */
    async findOne(store, options) {
        store.commit("IS_LOADING", !options.disabledLoading);
        const request = this.crudService.findOne(options);
        request
            .then((response) => {
            this.resolveSingleAction(store, response, options);
        })
            .catch((error) => {
            this.rejectReadAction(store, 
            // @ts-ignore
            String(i18n.global.t(error.response.data.error_message)), options);
        });
        return request;
    }
    /**
     * @param store
     * @param options
     */
    async findAll(store, options) {
        store.commit("IS_LOADING", true);
        return this.crudService
            .findAll(options)
            .then((response) => {
            this.resolveReadMultipleAction(store, response, options);
        })
            .catch((error) => {
            this.rejectReadAction(store, error, options);
        });
    }
    /**
     * @param store
     * @param options
     */
    async filter(store, options) {
        store.commit("IS_LOADING", true);
        return this.crudService
            .filter(options)
            .then((response) => {
            this.resolveReadMultipleAction(store, response, options);
        })
            .catch((error) => {
            this.rejectReadAction(store, error, options);
        });
    }
    /**
     * @param store
     * @param options
     */
    async create(store, options) {
        store.commit("IS_LOADING", !options.disabledLoading);
        store.commit("SET_SUCCESS", false);
        store.commit("SET_ERROR", null);
        return this.crudService
            .create(options)
            .then((response) => {
            const successMessage = options.successMessage
                ? options.successMessage
                : String(i18n.global.t("messages.save_success", {
                    item: response.data[options.descriptionField],
                }));
            this.resolveWriteAction(store, response, successMessage, response.data, options);
            store.commit("SET_SUCCESS", true);
        })
            .catch((error) => {
            this.rejectWriteAction(store, error, options);
            store.commit("SET_SUCCESS", false);
        });
    }
    /**
     * Same as create, but receives a result also
     * @param store
     * @param options
     */
    async simplePost(store, options) {
        store.commit("IS_LOADING", !options.disabledLoading);
        store.commit("SET_SUCCESS", false);
        store.commit("SET_DATA_ITEM", null);
        return this.crudService
            .create(options)
            .then((response) => {
            const successMessage = options.successMessage
                ? options.successMessage
                : String(i18n.global.t("messages.save_success", {
                    item: response.data[options.descriptionField],
                }));
            this.resolveWriteAction(store, response, successMessage, response.data, options);
            store.commit("SET_SUCCESS", true);
            store.commit("SET_DATA_ITEM", response.data);
        })
            .catch((error) => {
            this.rejectWriteAction(store, error, options);
            store.commit("SET_SUCCESS", false);
        });
    }
    /**
     * @param store
     * @param options
     */
    async update(store, options) {
        store.commit("IS_LOADING", true);
        store.commit("SET_SUCCESS", false);
        store.commit("SET_DATA_ID", null);
        store.commit("SET_ERROR", null);
        const request = this.crudService.update(options);
        request
            .then((response) => {
            const itemLabel = options.descriptionField;
            this.resolveWriteAction(store, response, String(i18n.global.t("messages.save_success", {
                item: itemLabel,
            })), response.data, options);
            store.commit("SET_DATA_ID", response.data ? response.data : -1);
            store.commit("SET_SUCCESS", true);
        })
            .catch((error) => {
            this.rejectWriteAction(store, error, options);
            store.commit("SET_SUCCESS", false);
            store.commit("SET_DATA_ID", null);
        });
        return request;
    }
    /**
     * @param store
     * @param options
     */
    async delete(store, options) {
        store.commit("IS_LOADING", true);
        store.commit("SET_DATA_DELETED", false);
        return this.crudService
            .delete(options)
            .then((response) => {
            store.commit("SET_DATA_DELETED", true);
            const resourceName = options.resource;
            const itemLabel = options.descriptionField ? options.descriptionField : String(i18n.global.t("general." + resourceName));
            this.resolveWriteAction(store, response, String(i18n.global.t("messages.delete_success", {
                resourceName: itemLabel,
            })), null, options);
            store.commit("SET_DATA_DELETED", true);
        })
            .catch((error) => {
            const { message, error_message } = error.response.data;
            this.rejectWriteAction(store, String(i18n.global.t(message ? message : error_message)), options);
            store.commit("SET_DATA_DELETED", false);
        });
    }
    resolveWriteAction(store, response, successMassage, item, options) {
        if (!options.hideSuccessMessage) {
            this.dispatchSuccessMessage(store, successMassage);
        }
        store.commit("SET_ERROR", null);
        store.commit("IS_LOADING", false);
    }
    /**
     * Actions to perform on write action promise reject
     * @param store
     * @param error
     */
    rejectWriteAction(store, error, options) {
        if (!options.hideErrorMessage) {
            this.dispatchError(store, error);
        }
        store.commit("SET_ERROR", error);
        store.commit("IS_LOADING", false);
    }
    /**
     * Actions to perform on read multiple action promise resolve
     * @param store
     * @param response
     */
    resolveReadMultipleAction(store, response, options) {
        if (response.data.data && response.data.data instanceof Array) {
            return this.resolveReadFilterAction(store, response, options);
        }
        else {
            return this.resolveReadFindAllAction(store, response, options);
        }
    }
    /**
     * Actions to perform on read multiple action promise resolve
     * @param store
     * @param response
     */
    resolveReadFilterAction(store, response, options) {
        store.commit("SET_DATA_LIST", response.data.data);
        store.commit("SET_TOTAL", response.data.total);
        store.commit("SET_ERROR", null);
        store.commit("IS_LOADING", false);
    }
    /**
     * Actions to perform on read multiple action promise resolve
     * @param store
     * @param response
     */
    resolveReadFindAllAction(store, response, options) {
        store.commit("SET_DATA_LIST", response.data);
        store.commit("SET_TOTAL", response.data.total);
        store.commit("SET_ERROR", null);
        store.commit("IS_LOADING", false);
    }
    /**
     * Actions to perform on read single action promise resolve
     * @param store
     * @param response
     */
    resolveSingleAction(store, response, options) {
        store.commit("SET_DATA_ITEM", response.data);
        store.commit("SET_ERROR", null);
        store.commit("IS_LOADING", false);
    }
    /**
     * Actions to perform on rad action promise reject
     * @param store
     * @param error
     */
    rejectReadAction(store, error, options) {
        const errorMassage = error.response?.data?.globalErrors ? error.response.data.globalErrors[0] : error;
        this.dispatchErrorMessage(store, errorMassage);
        store.commit("SET_ERROR", error);
        store.commit("IS_LOADING", false);
    }
    async dispatchError(store, error) {
        if (error.response?.status === 422) {
            let errorObject = error.response.data.fieldErrors && error.response.data.fieldErrors.length ? error.response.data.fieldErrors[0] : null;
            if (null === errorObject) {
                errorObject = error.response.data.globalErrors && error.response.data.globalErrors.length ? error.response.data.globalErrors[0] : null;
            }
            let errorMessage = "Unbekannter Fehler";
            if (!isString(errorObject)) {
                const errorMessage = null === errorObject || !errorObject.fieldName || !errorObject.error
                    ? "Unbekannter Fehler"
                    : errorObject.fieldName + " " + errorObject.error;
            }
            else {
                errorMessage = errorObject;
            }
            await this.dispatchErrorMessage(store, errorMessage);
        }
        else {
            await this.dispatchErrorMessage(store, error.message);
        }
    }
}
